import { Asset } from "../../Interfaces/Assets/Asset";

export class AssetHelper {
    GetPhotoSwipeItems(assets: Asset[]): PhotoSwipe.Item[] {
        let retVal: PhotoSwipe.Item[] = [];

        if (assets != null) {
            for (let asset of assets) {
                let resolutionSplit = asset.Resolution.split('x');

                let w: number = parseInt(resolutionSplit[0]);
                let h: number = parseInt(resolutionSplit[1]);

                retVal.push({
                    src: asset.Link,
                    w: w,
                    h: h
                })
            }
        }
        return retVal;
    }
}